import React, { useEffect, useState } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, Box, Typography, 
    List, ListItem, ListItemText, Divider, Chip, IconButton 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import * as API from '../api';
import { format } from 'date-fns';

const GlobalActivityLogDialog = ({ open, onClose }) => {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        if (open) {
            // Lấy 50 hoạt động gần nhất
            API.fetchGlobalActivityLogs({ limit: 50 })
                .then(res => setLogs(res.data.results || res.data)) // Tùy cấu hình pagination của Django
                .catch(console.error);
        }
    }, [open]);

    const renderChanges = (changes) => {
        if (!changes || Object.keys(changes).length === 0) return null;
        
        return (
            <Box sx={{ mt: 1, bgcolor: '#f0f4f8', p: 1.5, borderRadius: 2, border: '1px solid #e1e4e8' }}>
                <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                    Chi tiết thay đổi:
                </Typography>
                {Object.entries(changes).map(([key, val]) => (
                    <Box key={key} sx={{ display: 'flex', fontSize: '0.85rem', mb: 0.5, alignItems: 'center' }}>
                        <span style={{ fontWeight: 600, minWidth: 100, color: '#2c3e50' }}>• {key}:</span>
                        <span style={{ textDecoration: 'line-through', color: '#999', margin: '0 8px' }}>
                            {val.from || '(trống)'}
                        </span>
                        <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                            ➔ {val.to || '(trống)'}
                        </span>
                    </Box>
                ))}
            </Box>
        );
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ bgcolor: '#007373', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                NHẬT KÝ HOẠT ĐỘNG HỆ THỐNG
                <IconButton onClick={onClose} sx={{ color: 'white' }}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 0 }}>
                <List sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {logs.map((log, index) => (
                        <React.Fragment key={log.id}>
                            <ListItem alignItems="flex-start" sx={{ py: 1.5 }}>
                                <ListItemText
                                    primary={
                                        <Box display="flex" gap={1} alignItems="center" mb={0.5}>
                                            <Chip 
                                                label={log.action_type} 
                                                size="small" 
                                                color={log.action_type === 'CREATE' ? 'success' : (log.action_type === 'UPDATE' ? 'info' : 'error')} 
                                                sx={{ height: 20, fontSize: '0.65rem', fontWeight: 'bold' }}
                                            />
                                            <Typography variant="subtitle2" fontWeight="bold" color="#007373">
                                                {log.full_name || log.user_name || 'System'}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                • {format(new Date(log.created_at), 'dd/MM HH:mm')}
                                            </Typography>
                                        </Box>
                                    }
                                    secondary={
                                        <Box component="span">
                                            <Typography variant="body2" color="text.primary" sx={{fontWeight: 500}}>
                                                {log.description}
                                            </Typography>
                                            {renderChanges(log.changes)}
                                        </Box>
                                    }
                                />
                            </ListItem>
                            <Divider component="li" />
                        </React.Fragment>
                    ))}
                    {logs.length === 0 && (
                        <Typography sx={{ p: 3, textAlign: 'center', color: '#999' }}>Chưa có hoạt động nào.</Typography>
                    )}
                </List>
            </DialogContent>
        </Dialog>
    );
};

export default GlobalActivityLogDialog;